import { Button, Hidden, Typography } from "@mui/material";
import React, { Children, useEffect, useRef } from "react";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import "react-dropdown/style.css";

// const selectedButtonRef = useRef<HTMLButtonElement>(null);

function LeftArrow() {
  const { scrollPrev } = React.useContext(VisibilityContext);

  return (
    <Button onClick={() => scrollPrev()}>
      <ArrowLeftIcon />
    </Button>
  );
}

function RightArrow() {
  const { scrollNext } = React.useContext(VisibilityContext);

  return (
    <Button onClick={() => scrollNext()}>
      <ArrowRightIcon />
    </Button>
  );
}

interface Props {
  dateList: string[];
  handleDateChange: (event: any) => void;
  selectedDate: string;
}

export default function Timeline(this: any, props: Props) {
  const isDropdownVisible = true;

  const [date, setDate] = React.useState("");
  const scrollViewRef = useRef(null);

  const [value, setValue] = React.useState(0);
  const selectedButtonRef = useRef<HTMLButtonElement>(null);

  const options = props.dateList;
  const defaultOption = options[0];
  useEffect(() => {
    setTimeout(() => {
      if (selectedButtonRef.current && props.selectedDate) {
        selectedButtonRef.current.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }, 100);
    console.log("useEffect called");
    console.log("selectedButtonRef", selectedButtonRef.current);
  }, [props.selectedDate]);

  const handleChangeScroll = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setValue(newValue);
    console.log("setValue", newValue);
  };

  const [age, setAge] = React.useState("");

  const handleChange = (event: SelectChangeEvent) => {
    setAge(event.target.value as string);
    console.log("event", event.target.value);
  };

  return (
    <div className="flex flex-col">
      <Hidden mdUp>
        <div className="mb-2 flex flex-col ">
          <FormControl fullWidth style={{ width: "200px" }}>
            {/* <InputLabel id="demo-simple-select-label">Date</InputLabel> */}
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={props.selectedDate || "undefined"}
              label={date}
              onChange={props.handleDateChange}
              style={{
                height: "35px",
                alignContent: "center",
                color: "#4a5db5 ",
              }}
            >
              {props.dateList.map((date) => {
                return (
                  <MenuItem className="overflow-y-auto h-10" value={date}>
                    <div
                      style={{ color: "#4a5db5", fontSize: "15px" }}
                      className="pl-10 "
                    >
                      {date}
                    </div>
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </div>
      </Hidden>
      {!isDropdownVisible ? (
        <div>
          <Hidden mdDown>
            <div className="flex flex-row justify-around ">
              <div>
                <div
                  //   className="grid grid-cols-2 "
                  className="flex flex-row justify-between my-auto w-full  "
                  //   style={{ width: 850 }}
                ></div>
                <div style={{ width: "900px" }}>
                  <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>
                    {props.dateList.map((date: any) => {
                      return (
                        <div className="mx-2 my-4">
                          <Button
                            key={date}
                            data-date={date}
                            ref={
                              props.selectedDate === date
                                ? selectedButtonRef
                                : null
                            }
                            className={`date-button ${
                              props.selectedDate === date ? "selected" : ""
                            }`}
                            sx={{ outlineColor: "black", fontSize: "12px" }}
                            onClick={props.handleDateChange}
                            value={date}
                          >
                            {date}
                          </Button>
                        </div>
                      );
                    })}
                  </ScrollMenu>
                </div>
              </div>
            </div>
          </Hidden>
        </div>
      ) : (
        <Hidden mdDown>
          <div className="my-2 ">
            <FormControl fullWidth style={{ width: "240px" }}>
              {/* <InputLabel id="demo-simple-select-label">Date</InputLabel> */}
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={props.selectedDate || "undefined"}
                label={date}
                onChange={props.handleDateChange}
                style={{
                  height: "40px",
                  alignContent: "center",
                  color: "#4a5db5 ",
                  paddingLeft: "-4px",
                  marginTop: "-7px",
                  marginRight: "20px",
                }}
              >
                {props.dateList.map((date) => {
                  return (
                    <MenuItem className="overflow-y-auto h-10" value={date}>
                      <div
                        style={{ color: "#4a5db5", fontSize: "15px" }}
                        className="pl-16 "
                      >
                        {date}
                      </div>
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
        </Hidden>
      )}
    </div>
  );
}
